module.exports = __webpack_public_path__ + "img/yapital.c7a11e70.png";